export default {"src":"/hedera/_next/static/media/polygon.200df3c7.svg","height":10,"width":12};